import sliding from './animations/sliding-animation'
import add from './animations/add-split-by-animation'
import remove from './animations/remove-split-by-animation'
import exiting from './animations/exiting-serie-animation'
import thresholdChange from './animations/threshold-change-animation'
import basic from './animations/basic-animation'

export const animations = [
  sliding,
  add,
  remove,
  exiting,
  thresholdChange,
  basic
]
